//
import { Component } from "react"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"
import {
    ReceiptsTypeFilter,
    ReceiptsPartiesFilter,
    ReceiptsContributorTypeFilter,
    ReceiptsDateStartFilter,
    ReceiptsDateEndFilter,
    ReceiptsAmountMinFilter,
    ReceiptsAmountMaxFilter,
    ReceiptsElectionTypeFilter,
    ReceiptsCandidatesFilter,
    ReceiptsStatesFilter,
    ReceiptsContributorCommitteesFilter,
    ReceiptsContributorEmployersFilter,
    ReceiptsContributorOccupationsFilter,
    ReceiptsContributorCitiesFilter,
    ReceiptsContributorZipCodesFilter,
    ReceiptsContributorStatesFilter,
    ReceiptsCommitteesFilterInternal,
} from "shared/search/containers/Filter/ReceiptsFilter"

export class ReceiptsTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [ReceiptsTypeFilter, ReceiptsCommitteesFilterInternal, ReceiptsCandidatesFilter, ReceiptsStatesFilter],
        uniqueFilterGroupId: "receiptsTypeFilterGroup",
        displayLabel: "Recipient",
        helpText: "Filter by recipient.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class ReceiptsPartyFilterGroup extends Component {
    static defaultProps = {
        filters: [ReceiptsPartiesFilter],
        uniqueFilterGroupId: "receiptsPartyFilterGroup",
        displayLabel: "Party",
        helpText: "Filter by party.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class ReceiptsRecipientTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [
            ReceiptsContributorTypeFilter,
            ReceiptsContributorCommitteesFilter,
            ReceiptsContributorEmployersFilter,
            ReceiptsContributorOccupationsFilter,
            ReceiptsContributorCitiesFilter,
            ReceiptsContributorStatesFilter,
            ReceiptsContributorZipCodesFilter,
        ],
        uniqueFilterGroupId: "receiptsContributorTypeFilterGroup",
        displayLabel: "Contributor",
        helpText: "Filter by contributor.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class ReceiptsElectionTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [ReceiptsElectionTypeFilter],
        uniqueFilterGroupId: "receiptsElectionTypeFilterGroup",
        displayLabel: "Election type",
        helpText: "Filter by election type.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class ReceiptsDateFilterGroup extends Component {
    static defaultProps = {
        filters: [ReceiptsDateStartFilter, ReceiptsDateEndFilter],
        uniqueFilterGroupId: "receiptsDateFilterGroup",
        displayLabel: "Date",
        helpText: "Filter by date.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class ReceiptsAmountMinFilterGroup extends Component {
    static defaultProps = {
        filters: [ReceiptsAmountMinFilter, ReceiptsAmountMaxFilter],
        uniqueFilterGroupId: "ReceiptsAmountMinFilterGroup",
        displayLabel: "Amount",
        helpText: "Filter by amount.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
